import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../../shared/components/RedesignModal/RedesignModal.styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { formFieldStyles } from '../../../shared/styles/formField.styles';
import { redesignTheme } from '../../../theme';

const { spacing, colors, fonts, fontSize, radius, breakpoints, sizes } = redesignTheme;

export const useProfileFormStyles = makeStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
    width: '100%',
  },
  requiredHint: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    fontStyle: 'italic',
    color: colors.text,
  },
  sectionCard: {
    width: '100%',
    borderRadius: radius.md,
    border: `1px solid ${colors.cardWarmBorder}`,
    backgroundColor: colors.cardWarm,
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.sm,
    minHeight: 75,
    padding: `${spacing.sm}px ${spacing.md}px`,
    backgroundColor: colors.sectionHeaderBg,
    borderBottom: `1px solid ${colors.cardWarmBorder}`,
    boxSizing: 'border-box',
  },
  sectionIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.xs,
    borderRadius: radius.sm,
    backgroundColor: colors.iconSurface,
  },
  sectionIcon: {
    fontSize: 20,
    color: colors.text,
  },
  sectionTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 'normal',
  },
  sectionBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: spacing.sm,
    boxSizing: 'border-box',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.md,
    width: '100%',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  textarea: {
    ...formFieldStyles.textarea,
  },
  languageSelectorButton: {
    width: '100%',
    height: sizes.inputHeight,
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    gap: 10,
    padding: '0 12px',
  },
  deleteSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
    padding: spacing.sm,
    borderRadius: radius.md,
    backgroundColor: colors.dangerSurface,
    border: `1px solid ${colors.dangerBorder}`,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
    },
  },
  deleteContent: {
    display: 'flex',
    gap: spacing.sm,
    flex: 1,
    minWidth: 0,
  },
  deleteIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: radius.sm,
    backgroundColor: colors.dangerIconSurface,
    flexShrink: 0,
    boxSizing: 'border-box',
  },
  deleteIcon: {
    width: 21,
    height: 19,
    display: 'block',
  },
  deleteTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    minWidth: 0,
  },
  deleteTitle: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.textBody,
  },
  deleteDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.textBody,
    lineHeight: 1.5,
  },
  deleteButton: {
    ...secondaryButtonStyle,
    flexShrink: 0,
    color: colors.danger,
    textTransform: 'none',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: '100%',
    },
  },
  deleteButtonIcon: {
    fontSize: 16,
    marginRight: spacing.xs,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing.sm,
    justifyContent: 'flex-end',
    width: '100%',
  },
  cancelButton: {
    ...secondaryButtonStyle,
    textTransform: 'none',
  },
  saveButton: {
    ...primaryButtonStyle,
    textTransform: 'none',
    '&:disabled': {
      backgroundColor: colors.primaryDark,
      color: colors.white,
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  deleteModalPanel: {
    ...modalPaperStyle,
    maxWidth: 480,
  },
  deleteModalTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    lineHeight: 1.3,
  },
  deleteModalMessage: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.textBody,
    lineHeight: 1.5,
  },
  deleteModalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing.sm,
  },
  deleteModalCancelButton: {
    ...secondaryButtonStyle,
    textTransform: 'none',
  },
  deleteModalConfirmButton: {
    ...primaryButtonStyle,
    textTransform: 'none',
  },
}));
